import { ReactComponent as CheckboxSvg } from '@/commons/icons/check-box/check-box.svg';
import { ReactComponent as CheckedboxSvg } from '@/commons/icons/check-box/check-box-checked.svg';
import './multi-select.less'

export interface SelectOption {
    key: string,
    label: string,
}

interface Iprops {
    width?: number
    options?: SelectOption[]
    selectedKeys?: string[]
    handleSelectItem: (key: string) => void
}

export default function MultiSelect(props: Iprops) {
    return (
        <div className="tn-multi-select-wrap" style={{ width: props.width }}>
            {(props.options || []).map((item, index) => (
                <div key={index} className="option" onClick={(e) => {
                    props.handleSelectItem(item.key)
                }}>
                    <div className="label ellipsis">{item?.label}</div>
                    <div className='checkbox' >
                        {props.selectedKeys.includes(item.key) && <CheckedboxSvg />}
                        {!props.selectedKeys.includes(item.key) && <CheckboxSvg />}
                    </div>
                </div>
            ))}
            {(props.options || []).length == 0 && (
                <div>无数据</div>
            )}
        </div>
    )
}